/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamGradeCriteria200,
  GetApiV1ExamGradeCriteria401,
  GetApiV1ExamGradeCriteria500,
  GetApiV1ExamGradeCriteriaQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamGradeCriteria.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamGradeCriteria200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamGradeCriteria200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamGradeCriteria401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamGradeCriteria401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamGradeCriteria500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamGradeCriteria500>;

export const getApiV1ExamGradeCriteriaQueryResponseSchema = z.lazy(
  () => getApiV1ExamGradeCriteria200Schema,
) as unknown as ToZod<GetApiV1ExamGradeCriteriaQueryResponse>;
